import { post, PostWithData } from "../https";
import { Company, getCountry, getUserToken } from "../../../common/userfuctions";

const SERVER_URL = process.env.REACT_APP_HIRE_SIDE_API;


export const GetJobTitles = (title = "") => {
  const country = getCountry();
  let params = {
    r: "Jobs",
    rt: "GetJobTitles",
    member: 1,
    p: JSON.stringify({
      q: title,
      IPCountry: country,
    }),
  };

  return post(SERVER_URL, null, params);
};

export const GetJobLocations = (loc = "") => {
  const country = getCountry();
  let params = {
    r: "Jobs",
    rt: "GetJobLocations",
    p: JSON.stringify({
      q: loc,
      IPCountry: country,
    }),
  };

  return post(SERVER_URL, null, params);
};

export const GetJobRoleDepartments = () => {
  const country = getCountry();
  const params = {
    r: "Jobs",
    rt: "GetJobRoleDepartments",
    p: JSON.stringify({ IPCountry: country }),
  };

  return post(SERVER_URL, null, params);
};

export const getApplyJobForm = async (Source, FileName, editData, retryOpts = {}, tracking = {}) => {
  const UserToken = getUserToken();
  const country = getCountry();
  let params = {
    r: "Jobs",
    rt: "Apply",
    member: 1,
    p: JSON.stringify({
      rt2: "ApplyForm",
      AccessToken: UserToken,
      Source: Source,
      FileName,
      IPCountry: country,
      editData : editData,
      ...tracking
    }),
  };

  return post(SERVER_URL, null, params, {}, retryOpts);
};
export const getApplyJobFormEdit = async ( Source, FileName , editData ) => {
  const UserToken = getUserToken();
  const country = getCountry();
  let params = {
    r: "Jobs",
    rt: "Apply",
    member: 1,
    p: JSON.stringify({
      rt2: "ApplyForm",
      AccessToken: UserToken,
      Source: Source,
      FileName,
      IPCountry: country,
      editData : editData
    }),
  };

  return PostWithData(SERVER_URL, params, {});
};


export const ApplyFormSave = (jobCode, Data , countryCode = "", key = "", options = {}) => {
  const UserToken = getUserToken();
  const country = getCountry();
  const CurrentCompanyCode = countryCode ? countryCode : country;
  let params = {
    r: "Jobs",
    rt: "Apply",
    member: 1,
    p: JSON.stringify({
      rt2: "ApplyJob",
      AccessToken: UserToken,
      JobCode: jobCode,
      Data: Data,
      IPCountry: CurrentCompanyCode,
      key: key,
      ...options
    }),
  };

  return PostWithData(SERVER_URL, params, {});
};

export const ReviewAppliedJobs = (Data) => {
  const UserToken = getUserToken();
  const country = getCountry();

  let params = {
    r: "Jobs",
    rt: "Apply",
    member: 1,
    p: JSON.stringify({
      rt2: "ReviewAppliedJobs",
      AccessToken: UserToken,
      // JobCode: jobCode,
      Data: Data,
      IPCountry: country,
    }),
  };

  return PostWithData(SERVER_URL, params, {});
};

export const SearchJobs = (
  queryData,
  AccessToken = "",
  moreParams = {},
  Favorite = "0",
  countryCode
) => {
  const country = getCountry();
  let params = {
    r: "Jobs",
    rt: "GetJobs",
    p: JSON.stringify({
      IPCountry: countryCode ? countryCode : country,
      q: queryData.q,
      Filters: {
        jl: queryData.l,
      },
      pg: queryData.pg,
      AccessToken: AccessToken,
      Favorite: Favorite,
      Sync: queryData?.Sync ?? 0,
    }),
  };

  return post(SERVER_URL, null, params, moreParams);
};

export const GetJobInfo = (
  jobCode,
  AccessToken,
  moreParams = {},
  countryCode,

) => {
  const country = getCountry();
  let params = {
    r: "Jobs",
    rt: "GetJobInfo",
    p: JSON.stringify({
      JobCode: jobCode,
      AccessToken: AccessToken,
      InfoType: "Members",
      IPCountry: countryCode ? countryCode : country,
    }),
  };
  return post(SERVER_URL, null, params, moreParams);
};

export const GetMyJobs = () => {
  const UserToken = getUserToken();
  const country = getCountry();
  let params = {
    r: "Members",
    rt: "Private",
    member: 1,
    p: JSON.stringify({
      rt2: "AppliedJobs",
      rt3: "GetAppliedJobs",
      AccessToken: UserToken,
      IPCountry: country,
    }),
  };

  return post(SERVER_URL, null, params);
};

export const GetMemberJobInfo = (infoType, pageNo, slug) => {
  const UserToken = getUserToken();
  const country = getCountry();
  let params = {
    r: "Members",
    rt: "Private",
    member: 1,
    p: JSON.stringify({
      rt2: "MemberJobInfo",
      rt3: "MemberJobInfo",
      InfoType: infoType,
      [infoType]: { pg: pageNo },
      AccessToken: UserToken,
      MemberJobHistorySlug: slug,
      IPCountry: country,
    }),
  };

  return post(SERVER_URL, null, params);
};

export const FavouriteJob = (JobCode, AccessToken) => {
  const country = getCountry();
  let params = {
    r: "Members",
    rt: "Private",
    member: 1,
    p: JSON.stringify({
      rt2: "FavouriteJob",
      JobCode,
      AccessToken: AccessToken,
      IPCountry: country,
    }),
  };

  return post(SERVER_URL, null, params);
};

export const AddEmail = (slug, subject, message) => {
  const UserToken = getUserToken();
  const country = getCountry();
  let params = {
    r: "Members",
    rt: "Private",
    member: 1,
    p: JSON.stringify({
      rt2: "MemberJobInfo",
      rt3: "AddEmail",
      MemberJobHistorySlug: slug,
      Subject: subject,
      Message: message,
      AccessToken: UserToken,
      IPCountry: country,
    }),
  };

  return post(SERVER_URL, null, params);
};

export const ChangeInterviewStatus = (
  interviewStatus,
  interviewId,
  comment
) => {
  const UserToken = getUserToken();
  const country = getCountry();
  let params = {
    r: "Members",
    rt: "Private",
    member: 1,
    p: JSON.stringify({
      rt2: "MemberJobInfo",
      rt3: "ChangeInterviewStatus",
      AccessToken: UserToken,
      InterviewSlug: interviewId,
      Status: interviewStatus,
      Comment: comment,
      IPCountry: country,
    }),
  };

  return post(SERVER_URL, null, params);
};

export const ChangeOfferStatus = (offerStatus, offerId, comment) => {
  const UserToken = getUserToken();
  const country = getCountry();
  let params = {
    r: "Members",
    rt: "Private",
    member: 1,
    p: JSON.stringify({
      rt2: "MemberJobInfo",
      rt3: "ChangeOfferStatus",
      AccessToken: UserToken,
      OfferSlug: offerId,
      Status: offerStatus,
      Comment: comment,
      IPCountry: country,
    }),
  };

  return post(SERVER_URL, null, params);
};

export const ApplyJob = (jobCode, AccessToken = "") => {
  const country = getCountry();
  let params = {
    r: "Members",
    rt: "Private",
    member: 1,
    p: JSON.stringify({
      rt2: "ApplyJob",
      AccessToken: AccessToken,
      JobCode: jobCode,
      IPCountry: country,
    }),
  };

  return post(SERVER_URL, null, params);
};

export const FavoriteJob = (JobCode, AccessToken) => {
  const country = getCountry();
  let params = {
    r: "Members",
    rt: "Private",
    member: 1,
    p: JSON.stringify({
      rt2: "FavoriteJob",
      AccessToken: AccessToken,
      JobCode: JobCode,
      IPCountry: country,
    }),
  };

  return post(SERVER_URL, null, params);
};

export const getFavoriteJobs = () => {
  const UserToken = getUserToken();
  const country = getCountry();
  let params = {
    r: "Jobs",
    rt: "GetJobs",
    member: 1,
    p: JSON.stringify({
      AccessToken: UserToken,
      q: "",
      Favorite: 1,
      IPCountry: country,
    }),
  };

  return post(SERVER_URL, null, params);
};

export const getJobAlerts = () => {
  const UserToken = getUserToken();
  const country = getCountry();
  let params = {
    r: "Members",
    rt: "Private",
    member: 1,
    p: JSON.stringify({
      AccessToken: UserToken,
      rt2: "JobAlerts",
      rt3: "GetJobAlerts",
      IPCountry: country,
    }),
  };

  return post(SERVER_URL, null, params);
};

export const getJobAlertForm = () => {
  const UserToken = getUserToken();
  const country = getCountry();
  let params = {
    r: "Members",
    rt: "Private",
    member: 1,
    p: JSON.stringify({
      AccessToken: UserToken,
      rt2: "JobAlerts",
      rt3: "JobAlertForm",
      IPCountry: country,
    }),
  };

  return post(SERVER_URL, null, params);
};

export const onSubmitJobAlert = (data) => {
  const UserToken = getUserToken();
  const country = getCountry();

  let params = {
    r: "Members",
    rt: "Private",
    member: 1,
    p: JSON.stringify({
      AccessToken: UserToken,
      rt2: "JobAlerts",
      rt3: "AddJobAlert",
      Data: data,
      IPCountry: country,
    }),
  };

  return post(SERVER_URL, null, params);
};

export const onDeleteJobAlert = (id) => {
  const UserToken = getUserToken();
  const country = getCountry();
  let params = {
    r: "Members",
    rt: "Private",
    member: 1,
    p: JSON.stringify({
      AccessToken: UserToken,
      rt2: "JobAlerts",
      rt3: "DeleteJobAlert",
      MemberJobAlertId: id,
      IPCountry: country,
    }),
  };

  return post(SERVER_URL, null, params);
};

export const GetJobPostScreeningQuestions = (p) => {
  const UserToken = getUserToken();
  const country = getCountry();
  let params = {
    r: "Jobs",
    rt: "Apply",
    member: 1,
    p: JSON.stringify({
      rt2: "GetJobPostScreeningQuestions",
      AccessToken: UserToken,
      ...p,
      IPCountry: country,
    }),
  };

  return post(SERVER_URL, null, params);
};

export const SaveJobPostScreeningQuestions = (p) => {
  const UserToken = getUserToken();
  const country = getCountry();
  let params = {
    r: "Jobs",
    rt: "Apply",
    member: 1,
    p: JSON.stringify({
      rt2: "SaveJobPostScreeningQuestions",
      AccessToken: UserToken,
      ...p,
      IPCountry: country,
    }),
  };

  return post(SERVER_URL, null, params);
};

export const onSavedJobs = (JobCode) => {
  const UserToken = getUserToken();
  const country = getCountry();
  let params = {
    r: "Members",
    rt: "Private",
    member: 1,
    p: JSON.stringify({
      AccessToken: UserToken,
      rt2: "AddSaveforLater",
      JobCode: JobCode,
      IPCountry: country,
    }),
  };

  return post(SERVER_URL, null, params);
};
export const UnSaveforLater = (JobCode) => {
  const UserToken = getUserToken();
  const country = getCountry();
  let params = {
    r: "Members",
    rt: "Private",
    member: 1,
    p: JSON.stringify({
      AccessToken: UserToken,
      rt2: "UnSaveforLater",
      JobCode: JobCode,
      IPCountry: country,
    }),
  };

  return post(SERVER_URL, null, params);
}
export const getSavedJobs = (JobCode) => {
  const UserToken = getUserToken();
  const country = getCountry();
  let params = {
    r: "Members",
    rt: "Private",
    member: 1,
    p: JSON.stringify({
      AccessToken: UserToken,
      rt2: "GetSaveJobs",
      IPCountry: country,
    }),
  };

  return post(SERVER_URL, null, params);
};
